var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"layer_section type-wide-a mpn-modal",class:[_vm.addClass, _vm.classShowing],style:(_vm.styles),attrs:{"id":_vm.id ? _vm.id : null}},[_c('div',{ref:"refAnimateTarget",staticClass:"positioner",style:(_vm.styleContentVisible)},[(_vm.showing)?_vm._t("default"):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4de2a324","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/ModalLayout.vue
// module id = null
// module chunks = 